import { useQuery } from '@tanstack/react-query';
import { fetchActiveIecMaterialFormats } from '../../../api/administration/iecMaterialFormats';

export const useActiveIecMaterialFormats = (options = {}) => {
  const query = useQuery({
    queryKey: ['iecMaterialFormats', 'active'],
    queryFn: () => fetchActiveIecMaterialFormats(),
    enabled: options.enabled !== false,
  });

  return {
    ...query,
    iecMaterialFormats: query.data?.data?.iecMaterialFormats ?? [],
  };
};

export default useActiveIecMaterialFormats;
